/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ContactDealerInlineForm_user$ref = any;
type PdpRespDealerDetailsStats_user$ref = any;
type PdpSharedCallDealerCta_user$ref = any;
type PdpSharedSellerTabsVariant_user$ref = any;
export type PdpRespDealerDetails_user$ref = any;
export type PdpRespDealerDetails_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": PdpRespDealerDetailsStats_user$ref & ContactDealerInlineForm_user$ref & PdpSharedSellerTabsVariant_user$ref & PdpSharedCallDealerCta_user$ref;
    readonly " $refType": PdpRespDealerDetails_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespDealerDetails_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespDealerDetailsStats_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "ContactDealerInlineForm_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedSellerTabsVariant_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedCallDealerCta_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = '70f70df30d188958adaa9aaf397b420e';
export default node;
